import PHASE from 'utils/constants/phases'
import LOG from 'utils/constants/logs'
import { sortBy } from 'lodash'
import { normalizeById } from 'utils/normalizer'

export function gameDataFromLogs(game, players, logs = []) {
    const sortedLogs = logs.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    let newGame = game
    let playersById = normalizeById(players, 'id')
    let timeline = []
    for (let i = sortedLogs.length - 1; i >= 0; i--) {
        const newData = updateGameDataWithLog(newGame, playersById, sortedLogs[i])
        newGame = newData.game
        playersById = newData.playersById
        timeline = [newData.log, ...timeline]
    }
    return { game: newGame, playersById, timeline }
}
export function updateGameDataWithLog(game, playersById, log) {
    return {
        game: updateGameWithLog(game, log),
        playersById: updatePlayersWithLog(playersById, log),
        log: logToTimelineLog(log)
    }
}
function updateGameWithLog(game, { type, currentSeason, currentRace, phase, remainingSeconds }) {
    if (type === LOG.PHASE_UPDATE) {
        return {
            ...game,
            currentSeason,
            currentRace,
            phase,
            remainingSeconds
        }
    }
    return game
}
function updatePlayersWithLog(playersById, { type, phase, playerId, selection = {}, data = {} }) {
    if (type === LOG.PLAYER_PHASE_FINISHED && phase === PHASE.INTRO) {
        const player = playersById[playerId]
        return {
            ...playersById,
            [playerId]: {
                ...player,
                name: selection.name || player.name,
                nickname: selection.nickname || player.nickname,
            }
        }
    }
    if (type === LOG.PHASE_UPDATE && phase === PHASE.RACE) {
        if ((data.result || []).length > 0) {
            return {
                ...playersById,
                ...normalizeById(data.result.map(player => {
                    const prevPlayer = playersById[player.playerId] || {}
                    return { ...prevPlayer, ...player, id: prevPlayer.id || player.playerId }
                }))
            }
        }
    }
    return playersById
}
function logToTimelineLog(log) {
    if (log.type === LOG.PHASE_UPDATE && log.phase === PHASE.RACE) {
        return {
            ...log,
            data: {
                result: sortBy(log.data.result || [], ['position', (p => -p.points), 'time'])
            }
        }
    }
    if (log.type === LOG.PHASE_UPDATE && log.phase === PHASE.POST_SEASON) {
        return {
            ...log,
            data: {
                byPoints: sortBy(log.data.byPoints || [], ['position', (p => -p.totalPoints), 'totalTime']),
                byProfitability: sortBy(log.data.byProfitability || [], ['position', (p => -p.profitability), 'credits']),
            }
        }
    }
    return log
}



// WEBPACK FOOTER //
// src/utils/dataEnhancer/logs.js